export const initialUserState = { isAuthenticated: false };
export const initialShipmentState = {
  create: {
    shipment_reference_no: "",
    required_on: "",
    route_code: "",
    proposed_vehicle_type: "",
    source: "",
    destination: "",
    no_of_vehicles: "",
    movement_type: "",
    base_rate: "",
    remark: "",
  },
  read: [],
};
export const initialOrderState = {
  read: []
}
export const initialCurrentOrderState = {
  read: {}
}
export const initialPermissionState = {
  DASHBOARD: { VIEW: false, CREATE: false, UPDATE: false, DELETE: false },
  DOCUMENTS: { VIEW: false, CREATE: false, UPDATE: true, DELETE: true, UPLOAD: true, DOWNLOAD: true },
  REPORTS: { VIEW: false, CREATE: false, UPDATE: true, DELETE: true },
  SHIPMENT: { VIEW: false, CREATE: false, UPDATE: false, DELETE: false, UPLOAD: false },
  TA_CHECKPOINT_MASTER: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_CITY_MASTER: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_CONSIGNEE_MASTER: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_CONSIGNOR_MASTER: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_DASHBOARD: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_DOCUMENTS: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true, UPLOAD: true, DOWNLOAD: true },
  TA_DRIVER_MASTER: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_REPORTS: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_ROUTE_MASTER: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_SHIPMENT: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true, UPLOAD: true },
  TA_SKU_MASTER: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_USER_MASTER: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_USER_ROLE: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_VEHICLE_MASTER: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_VEHICLE_TYPE_MASTER: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_VENDOR_GROUP: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_VENDOR_MASTER: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
  TA_VENDOR_SHARE: { VIEW: true, CREATE: true, UPDATE: true, DELETE: true },
};
export const initialLocaleState = {
  local: "en",
};
export const initialAlertState = {};
export const initialPaginationState = {
  active_order_card_page: 1,
  active_order_grid_page: 1,
  allocated_order_card_page: 1,
  allocated_order_grid_page: 1,
  vehicle_reporting_card_page: 1,
  vehicle_reporting_grid_page: 1,
}
